



















import { Component, Vue } from "vue-property-decorator";
@Component
export default class logos extends Vue {
  // 用户设置的icon图标
  private icon: string|null = localStorage.getItem("icon");// TODO 后期改到vuex中实现
  // 搜索引擎配置    TODO 后期动态获取
  private searchs: Array<object> = [
    {
      action: "https://www.google.com/search",
      name: "q", // 搜索按钮input的name属性
      title: "google",
      icon: "./img/google.png",
      lenovo: ""
    },
    {
      action: "https://www.sogou.com/web",
      name: "query",
      title: "sougou",
      icon: "./img/sougou.png"
    },
    {
      action: "https://www.baidu.com/s",
      name: "wd",
      title: "baidu",
      icon: "./img/baidu.png",
      lenovo: "http://suggestion.baidu.com/su"
    }
  ];
  constructor() {
      super(); 
              //初期化创建默认值
        var i = localStorage.getItem('icon');
        if ('null' == i || undefined == i) {
            //TODO 让用户判断默认搜索引擎
            //设置本地默认logo
            localStorage.setItem('icon', './img/google.png');
            //设置本次默认logo
            this.icon = './img/google.png';
            // setTimeout(() => {
            //     search.word = '点击logo切换搜索引擎'
            // }, 10);
            localStorage.setItem("action", "https://www.google.com/search");
            localStorage.setItem("name", "q");
            this.$store.commit('setAction',localStorage.getItem("action"));
            this.$store.commit('setName',localStorage.getItem("name"));
        }

  }

  public clear():void{
            // if (search.word == '点击logo切换搜索引擎') {
            //     search.word = ''
            // }
  }

  public change(item:any):void{
                  //切换搜索action
           // search.action = item.action; //TODO 写到本地保存
            localStorage.setItem('action', item.action);
            this.$store.commit('setAction',item.action);
            this.$store.commit('setName',item.name);
            //设置搜索输入框的name属性
           //search.name = item.name;
            localStorage.setItem('name', item.name)
            this.icon = item.icon;
            localStorage.setItem('icon', item.icon)
            //手机端特别处理
            if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                window.location.href="移动端url";
                if (item.title == 'baidu') {
                   // search.action = 'https://m.baidu.com/s';
                    localStorage.setItem('action', 'https://m.baidu.com/s');
                }

            }
        }
}
